import { SegmentListItem } from '@/models/dictionary/segment-list.model';

export const segmentListToSegmentIdList = (segmentList: SegmentListItem[]): string[] => {
  return segmentList.map(({ id }: SegmentListItem) => id);
};
